import { Dialog, Transition } from "@headlessui/react";
import axios from "axios";
import Cookies from "js-cookie";
import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { toast } from "react-toastify";
import AppContext from "../../context/AppContext";
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import { fetchTasks } from "../../service/Task";
import CommonButton from "../../components/common/CommonButton";
import translations from "../../components/common/Translations";
export default function FieldAgentModal({
  setAssignOpen,
  assignOpen,
  handleSaveTask,
  selectedfieldAgent,
  setselectedfieldAgent,
  isCreateLoading
}) {
  const context = useContext(AppContext);
  const {
    workflowId,
    setSelectAll,
    userType,
    setPriority,
    setActive,
    setSelectedUserId,
    setSelectedUserName,
    selectedOrgId,
  } = context;
  const [fieldAgent, setFieldAgent] = useState();
  // const [selectedfieldAgent, setselectedfieldAgent] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // New state variable
  const cancelButtonRef = useRef(null);
  const { theme,langMode,activityId } = useContext(AppContext);
  const [allFieldAgents, setAllFieldAgents] = useState([]);
  const [displayedAgents, setDisplayedAgents] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  useEffect(() => {}, [fieldAgent]);

  useEffect(() => {
    console.log("activity id: ", activityId)
    if (assignOpen && !isDataFetched && activityId) {
      const fetchData = (activityId) => {
        const token = Cookies.get("accessToken");
        let organizationQuery = "";
        if (userType === "super_admin" && selectedOrgId) {
          organizationQuery = `&organizationId=${selectedOrgId}`;
        }
        axios
          .get(
              `${process.env.REACT_APP_BASE_BACKEND_API_URL}api/v1/user/field-agents-by-workflow?workflowId=${activityId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            if (response.data.body.value) {
              setFieldAgent(response.data.body.value);
              setAllFieldAgents(response.data.body.value);
              setDisplayedAgents(response.data.body.value); // Show first 10 records initially
            } else {
              setError("No field agents found");
            }
            setIsDataFetched(true);
          })
          .catch((error) => {
            console.error("An error occurred:", error);
          });
      };
      fetchData(activityId);
    }
    if (!assignOpen) {
      setIsDataFetched(false);
    }
  }, [assignOpen, isDataFetched]);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredAgents = allFieldAgents.filter(agent =>
      agent.name.toLowerCase().includes(query)
    );
    setDisplayedAgents(filteredAgents);
  };
  const handleFieldAgentSelect = (userId) => {
    setselectedfieldAgent((prevAgents) => {
      let updatedAgents;
      if (prevAgents.includes(userId)) {
        updatedAgents = prevAgents.filter((agentId) => agentId !== userId); // Deselect
      } else {
        updatedAgents = [...prevAgents, userId]; // Select
      }
      console.log("Updated Field Agents: ", updatedAgents); // Log updated list
      return updatedAgents;
    });
  };

  return (
    <Transition.Root show={assignOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setAssignOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={`fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity `}
          />
        </Transition.Child>
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative transform overflow-hidden rounded-lg bg-white text-left
               shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg ${
                 theme === "dark"
                   ? "dark-mode "
                   : theme === "high-contrast"
                   ? "high-contrast  "
                   : ""
               }`}
              >
                <div
                  className={`bg-white rounded-lg shadow  ${
                    theme === "dark"
                      ? "dark-mode "
                      : theme === "high-contrast"
                      ? "high-contrast  "
                      : ""
                  }`}
                >
                  <div className="flex items-center gap-10 p-2 md:p-5  rounded-t dark:border-gray-600">
                    <h3 className="text-sm font-semibold text-gray-900 dark:text-white">
                    {translations[langMode].FieldStaffList}
                    </h3>
                    {/* <button
                      type="button"
                      disabled={selectedfieldAgent.length === 0} // Disable only if no agents are selected
                      onClick={handleSaveTask} // Ensure handleSaveTask is called when clicked
                      className="px-3 py-2 text-xs font-medium text-center inline-flex items-center text-white bg-blue-800 rounded-lg hover:bg-blue-900 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                      Assign
                    </button> */}

                    <CommonButton
                      disabled={selectedfieldAgent.length === 0}
                      onClick={handleSaveTask}
                      variant="primary"
                      className={`${isCreateLoading ? "bg-opacity-60" : "bg-opacity-100"}`}
                    >
                      {isCreateLoading ? "Assigning..." :"Assign"}
                    </CommonButton>

                    <button
                      type="button"
                      className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                      data-modal-hide="small-modal"
                      onClick={() => setAssignOpen(false)}
                    >
                      <RxCross2 />
                      <span className="sr-only">Close modal</span>
                    </button>
                  </div>
                  <div className="p-2 md:p-5 space-y-4 overflow-y-auto h-auto max-h-[250px] ">
                    <input
                      type="text"
                      placeholder="Search field agents..."
                      value={searchQuery}
                      onChange={handleSearch}
                      className="w-full mb-2 p-2 border border-gray-300 rounded-md text-xs"
                    />
                    {error ? (
                      <div className="text-red-500">{error}</div>
                    ) : (
                      displayedAgents &&
                      displayedAgents.map((agent, index) => (
                        <div
                          className={`bg-white p-3 border border-gray-300 mt-2 
                            ${
                              theme === "dark"
                                ? "dark-mode "
                                : theme === "high-contrast"
                                ? "high-contrast  "
                                : ""
                            }`}
                        >
                          <div className="flex items-center">
                            <input
                              id="default-radio-1"
                              type="checkbox"
                              value=""
                              name="default-radio"
                              onClick={() =>
                                handleFieldAgentSelect(agent.userId)
                              }
                              checked={selectedfieldAgent.includes(
                                agent.userId
                              )}
                              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            />
                            <label
                              for="default-radio-1"
                              className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                              {agent.name}
                            </label>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
